import styled, { css } from 'styled-components';
import { FormMessage } from '../form-message/index.js';
import { getMargins, SYS_SPACE_FIXED_50, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SEM_TYPOGRAPHY_FORMS_INPUT, SEM_TYPOGRAPHY_FORMS_APPENDIX, SEM_TYPOGRAPHY_FORMS_RANGE, SYS_SIZE_FIXED_600, SEM_BORDER_WIDTH_FORMS_DEFAULT, getTypographyStyles, SYS_SIZE_FIXED_300, SEM_TYPOGRAPHY_FORMS_LABEL, SYS_SIZE_FIXED_800, SYS_SPACE_FIXED_25, SYS_SIZE_FIXED_150, SYS_BORDER_RADIUS_MAX, SYS_BORDER_RADIUS_SM, SYS_BLUR_BACKGROUND_100, CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_FILL_DEFAULT_DARK, CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_FILL_DEFAULT_LIGHT, CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_DEFAULT_DARK, CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_DEFAULT_LIGHT, CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_ERROR_DARK, CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_ERROR_LIGHT } from '@oneaudi/unified-web-alpha-common';
import {} from './index.js';
const injectThumb = css `
  width: var(--thumb-width);

  ${(props) => {
    const thumbBackgroundToken = props.disabled
        ? props.theme.cmp.color.forms.slider.surface.handle.fill.disabled
        : props.invalid
            ? props.theme.cmp.color.forms.slider.surface.handle.fill.error
            : props.theme.cmp.color.forms.slider.surface.handle.fill.default;
    const thumbBorderToken = props.disabled
        ? props.theme.cmp.color.forms.slider.surface.handle.stroke.disabled
        : props.invalid
            ? props.theme.cmp.color.forms.slider.surface.handle.stroke.error
            : props.theme.cmp.color.forms.slider.surface.handle.stroke.default;
    const theme = props.theme.name;
    // Hard-coded values are used for disabled state below due to SVG blur limitations
    const thumbBackgroundColor = theme === 'dark'
        ? props.disabled
            ? '#2b303b'
            : CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_FILL_DEFAULT_DARK
        : props.disabled
            ? '#C4C9D4'
            : CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_FILL_DEFAULT_LIGHT;
    const thumbBorderColor = props.disabled
        ? theme === 'dark'
            ? '#363d49'
            : '#A7AFBE'
        : props.invalid
            ? theme === 'dark'
                ? CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_ERROR_DARK
                : CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_ERROR_LIGHT
            : theme === 'dark'
                ? CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_DEFAULT_DARK
                : CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_DEFAULT_LIGHT;
    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" id="Idle" viewBox="0 0 26 24">

        <g>
          <path fill="${thumbBackgroundColor}"  d="M7 18.5C3.42 18.5.5 15.58.5 12S3.42 5.5 7 5.5h12c3.58 0 6.5 2.92 6.5 6.5s-2.92 6.5-6.5 6.5z" />
          <path fill="${thumbBorderColor}"  d="M19 6c3.31 0 6 2.69 6 6s-2.69 6-6 6H7c-3.31 0-6-2.69-6-6s2.69-6 6-6zm0-1H7c-3.87 0-7 3.13-7 7s3.13 7 7 7h12c3.87 0 7-3.13 7-7s-3.13-7-7-7" />
        </g>
        <path fill="none" d="M1 0h24v24H1z" />
      </svg>
    `.trim();
    const utf8Bytes = new TextEncoder().encode(svg);
    const binary = String.fromCharCode(...Array.from(utf8Bytes));
    const base64 = btoa(binary);
    const dataUrl = `data:image/svg+xml;base64,${base64}`;
    return props.valueIsArray
        ? css `
          height: var(--thumb-click-height);
          width: var(--thumb-width);
          background-image: url('${dataUrl}');
          background-repeat: no-repeat;
          background-size: contain;
          background-color: transparent;
          background-position: center;
          border: none;
          border-radius: 0px;
        `
        : css `
          height: var(--thumb-visual-height);
          background-color: ${thumbBackgroundToken};
          backdrop-filter: ${props.disabled
            ? `blur(${SYS_BLUR_BACKGROUND_100})`
            : 'none'};
          border: ${SEM_BORDER_WIDTH_FORMS_DEFAULT} solid ${thumbBorderToken};
          border-radius: ${SYS_BORDER_RADIUS_MAX};
        `;
}};

  box-sizing: content-box;
  pointer-events: auto;
  box-shadow: none;
  appearance: none;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'grab')};

  &:active {
    cursor: ${(props) => (!props.disabled ? 'grabbing' : 'inherit')};
  }
`;
export const StyledOuterContainer = styled.div `
  margin: ${(props) => getMargins(props.margin) || 0};
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  --range: calc(var(--max) - var(--min));

  --thumb-width: ${SYS_SIZE_FIXED_600};
  --thumb-click-height: ${SYS_SIZE_FIXED_600};
  --thumb-visual-height: ${SYS_SIZE_FIXED_300};
  --thumb-half: calc(var(--thumb-width) / 2);
  --output-container-height: calc(
    ${SYS_SIZE_FIXED_800} - ${SYS_SPACE_FIXED_25}
  );
  --output-height: calc(
    ${SEM_TYPOGRAPHY_FORMS_INPUT.lineHeight} + ${SYS_SPACE_FIXED_25} * 2
  );
  --output-translate: calc(
    -1 * (var(--output-container-height) - var(--output-height))
  );

  --ratio0: calc((var(--value0) - var(--min)) / var(--range));
  --position0: calc(
    var(--thumb-half) + (var(--ratio0) * (100% - var(--thumb-width)))
  );

  ${(props) => props.valueIsArray === true &&
    css `
      --ratio1: calc((var(--value1) - var(--min)) / var(--range));
      --position1: calc(
        var(--thumb-half) + (var(--ratio1) * (100% - var(--thumb-width)))
      );

      --midpoint: calc((var(--position0) + var(--position1)) / 2);
    `}
`;
export const StyledTextContent = styled.div `
  display: flex;
  justify-content: start;
  align-items: flex-end;
  gap: ${SYS_SPACE_FIXED_100};
  padding-bottom: ${SYS_SPACE_FIXED_50};
`;
export const StyledLabel = styled.label `
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)};

  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.field.label.disabled
    : props.theme.sem.color.forms.foreground.field.label.default};
`;
export const StyledAppendix = styled.div `
  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.field.appendix.disabled
    : props.theme.sem.color.forms.foreground.field.appendix.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_APPENDIX)};
`;
export const StyledControlContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${SYS_SPACE_FIXED_150};
`;
export const StyledIconButtonWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_50};
`;
export const StyledSlider = styled.input.attrs({
    type: 'range'
}) `
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: absolute;
  width: 100%;
  height: var(--thumb-click-height);
  background: transparent;
  border: none;
  margin: 0;
  padding: 0;
  opacity: 1;
  top: 0px;

  ${(props) => props.valueIsArray &&
    css `
      pointer-events: none;
      &:focus-visible::-webkit-slider-thumb {
        outline: 2px solid -webkit-focus-ring-color;
      }

      &:focus-visible::-moz-range-thumb {
        outline: 2px solid Highlight;
      }

      &:focus-visible::-ms-thumb {
        border: 2px solid Highlight;
      }

      &:focus:not(:focus-visible),
      &:focus-within {
        outline: none;
      }
    `}

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    ${injectThumb}
  }

  &::-moz-range-thumb {
    -moz-appearance: none;
    ${injectThumb}
  }

  &::-ms-thumb {
    ${injectThumb}
  }

  &::-webkit-slider-runnable-track,
  &::-moz-range-track {
    pointer-events: none;
  }
`;
export const StyledOutput = styled.output `
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_INPUT)};
  flex-shrink: 0;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: background-color, color, transform;
  text-wrap: nowrap;

  ${(props) => props.disabled
    ? css `
          color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};
        `
    : props.invalid
        ? css `
            color: ${(props) => props.theme.sem.color.forms.foreground.text.error};
          `
        : css `
            color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
          `}

  ${(props) => props.valueIsArray === false &&
    css `
      @supports (width: min(1px, 2px)) and (width: max(1px, 2px)) {
        --output-position: calc(
          max(
            0px,
            min(
              calc(var(--position0) - (var(--output-size) / 2)),
              calc(100% - var(--output-size))
            )
          )
        );
        position: absolute;
        border-radius: ${SYS_BORDER_RADIUS_SM};
        padding: ${SYS_SPACE_FIXED_25} ${SYS_SPACE_FIXED_100};
        left: var(--output-position);
        bottom: 0;
        transform: translateY(0);
      }
    `}
`;
export const StyledOutputContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: ${SYS_SIZE_FIXED_800};
  padding-top: ${SYS_SPACE_FIXED_25};
  box-sizing: border-box;

  ${(props) => props.valueIsArray === false &&
    css `
      position: relative;
      display: block;
    `}
`;
export const StyledDisplayContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  &:has(${StyledSlider}:hover:not(:disabled)) {
    & ${StyledOutput} {
      color: ${(props) => props.theme.sem.color.forms.foreground.text.interactive};
      ${(props) => props.valueIsArray === false &&
    css `
          background-color: ${props.theme.sys.color.surface.neutral[100]};
          color: ${props.theme.sys.color.surface.neutral[800]};
          transform: translateY(var(--output-translate));
        `};
    }
  }

  &:has(${StyledSlider}:focus:not(:disabled)) {
    & ${StyledOutput} {
      color: ${(props) => props.theme.sem.color.forms.foreground.text.interactive};
      ${(props) => props.valueIsArray === false &&
    css `
          background-color: ${props.theme.sys.color.surface.neutral[100]};
          color: ${props.theme.sys.color.surface.neutral[800]};
          transform: translateY(var(--output-translate));
        `};
    }
  }

  &:has(${StyledSlider}:focus-visible:not(:disabled)) {
    & ${StyledOutput} {
      color: ${(props) => props.theme.sem.color.forms.foreground.text.interactive};
      ${(props) => props.valueIsArray === false &&
    css `
          background-color: ${props.theme.sys.color.surface.neutral[100]};
          color: ${props.theme.sys.color.surface.neutral[800]};
          transform: translateY(var(--output-translate));
        `};
    }
  }
`;
export const StyledTrack = styled.div `
  --gradient-direction: to right;
  height: ${SYS_SIZE_FIXED_150};
  position: relative;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);

  &::before {
    content: '';
    z-index: 2;
    width: 100%;
    position: absolute;
    inset: 0;
    border-radius: ${SYS_BORDER_RADIUS_MAX};
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
    transition-duration: 250ms;
    transition-property: background;

    ${(props) => {
    if (props.valueIsArray) {
        return css `
          background: linear-gradient(
            var(--gradient-direction),
            ${props.theme.cmp.color.forms.slider.surface.track.default}
              var(--start),
            ${props.disabled
            ? props.theme.cmp.color.forms.slider.surface.progress.disabled
            : props.invalid
                ? props.theme.cmp.color.forms.slider.surface.progress.error
                : props.theme.cmp.color.forms.slider.surface.progress.default}
              var(--start),
            ${props.disabled
            ? props.theme.cmp.color.forms.slider.surface.progress.disabled
            : props.invalid
                ? props.theme.cmp.color.forms.slider.surface.progress.error
                : props.theme.cmp.color.forms.slider.surface.progress.default}
              var(--end),
            ${props.theme.cmp.color.forms.slider.surface.track.default}
              var(--end)
          );
        `;
    }
    else {
        return css `
          background: linear-gradient(
            var(--gradient-direction),
            ${props.disabled
            ? props.theme.cmp.color.forms.slider.surface.progress.disabled
            : props.invalid
                ? props.theme.cmp.color.forms.slider.surface.progress.error
                : props.theme.cmp.color.forms.slider.surface.progress.default}
              var(--position0),
            ${props.theme.cmp.color.forms.slider.surface.track.default}
              var(--position0)
          );
        `;
    }
}};
  }
`;
export const StyledSliderContainer = styled.div `
  height: ${SYS_SIZE_FIXED_600};
  position: relative;

  &:has(${StyledSlider}:hover:not(:disabled)) {
    & ${StyledTrack} {
      &::before {
        ${(props) => {
    if (props.valueIsArray) {
        return css `
              background: linear-gradient(
                var(--gradient-direction),
                ${props.theme.cmp.color.forms.slider.surface.track.default}
                  var(--start),
                ${props.theme.cmp.color.forms.slider.surface.progress
            .interactive}
                  var(--start),
                ${props.theme.cmp.color.forms.slider.surface.progress
            .interactive}
                  var(--end),
                ${props.theme.cmp.color.forms.slider.surface.track.default}
                  var(--end)
              );
            `;
    }
    else {
        return css `
              background: linear-gradient(
                var(--gradient-direction),
                ${props.theme.cmp.color.forms.slider.surface.progress
            .interactive}
                  var(--position0),
                ${props.theme.cmp.color.forms.slider.surface.track.default}
                  var(--position0)
              );
            `;
    }
}}
      }
    }
  }
`;
export const StyledMinMax = styled.div `
  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.field.caption.disabled
    : props.theme.sem.color.forms.foreground.text.caption};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_RANGE)};
  display: flex;
  justify-content: space-between;
  padding-top: ${SYS_SPACE_FIXED_100};
`;
export const StyledFormMessage = styled(FormMessage) `
  padding-top: ${SYS_SPACE_FIXED_150};
`;
//# sourceMappingURL=index.styles.js.map